// HelpBot admin modules;
import app from './app';

const dialogs = {};

for (var ith = 0; ith < app.menu.length; ith++) {
   for (var jth = 0; jth < app.menu[ith].items.length; jth++) {
      var file = app.menu[ith].items[jth].replaceAll(' ', '');
      dialogs[file] = require('./' + file).default;
   }
}

const Body = () => {

   if (0 === app.state.user_id) app.state.mode = 'LogIn';

   const Dialog = dialogs[app.state.mode];

   if ('function' === typeof Dialog) return (<div className="ask-henry-body"><Dialog /></div>);

   return null;

} // Body();

export default Body;
